module.exports = __webpack_public_path__ + "media/images/admin2/Nav__handle--white-ec7ee88672b4851669fe325d69630636.svg";